const QuestLoader = () => {
  return (
    <div className="bg-shire-light font-body text-shire-dark fixed inset-0 z-50 flex flex-col items-center justify-center">
      <div className="relative mb-6 size-24">
        <div className="border-shire-moss border-t-shire-pine absolute inset-0 animate-spin rounded-full border-4" />
        <div className="border-shire-bark absolute inset-2 animate-pulse rounded-full border-2 border-dashed" />
      </div>
      <h2 className="font-heading mb-2 text-2xl">Preparing your quest…</h2>
      <p className="text-shire-bark text-sm italic">
        Summoning scrolls, sharpening swords, setting coordinates...
      </p>
    </div>
  )
}

export default QuestLoader
